import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStaticPlaceholderGroup from 'components/consumer/ProductCardStaticPlaceholderGroup';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';

// Full-height grid of card placeholders. Reserves the product grid's vertical
// space so content below it (notably the category description) does not float
// up and then get shoved down when real products render.
const ProductsGridSkeleton = t0 => {
  const $ = _c(5);
  const {
    count
  } = t0;
  const mobileColumnCount = useMobileColumnCount();
  let t1;
  if ($[0] !== count) {
    t1 = <ProductCardStaticPlaceholderGroup count={count} />;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== mobileColumnCount || $[3] !== t1) {
    t2 = <div className="min-h-[400px]"><ProductCardGridUI limitWidth={false} columnsOnDesktop="auto" columnsOnMobile={mobileColumnCount}>{t1}</ProductCardGridUI></div>;
    $[2] = mobileColumnCount;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default ProductsGridSkeleton;